import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Spin, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

import getMerchantInvoiceCountDetail from "functions/merchant/getMerchantInvoiceCountDetail";
import moneyFormat from "functions/utils/moneyFormat";
import * as XLSX from "xlsx";
import { bg_button, bg_shadow } from "constant/css";

const CountPreview = ({ open, close, invoiceId }) => {
  const merchantId = localStorage.getItem("merchantId");
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const printRef = useRef();
  const [downloading, setDownloading] = useState(false);
  const totalCount = invoice?.merchantInvoiceCountDetails?.reduce(
    (sum, item) => sum + item.count,
    0
  );
  const totalAmount = invoice?.merchantInvoiceCountDetails?.reduce(
    (sum, item) => sum + parseFloat(item.total),
    0
  );
  useEffect(() => {
    const fetchInvoice = async () => {
      setLoading(true);
      try {
        const response = await getMerchantInvoiceCountDetail(
          merchantId,
          invoiceId
        );
        if (!response) throw new Error("No response");
        setInvoice(response);
      } catch (error) {
        console.error("Error fetching invoice:", error);
        message.error("Failed to fetch invoice details");
      } finally {
        setLoading(false);
      }
    };
    if (invoiceId) fetchInvoice();
  }, [invoiceId]);

  const exportToExcel = () => {
    if (!invoice?.merchantInvoiceCountDetails) {
      message.error("Мэдээлэл байхгүй байна.");
      return;
    }
    if (downloading) {
      message.error("Татаж байна, дахин оролдоно уу.");
      return;
    }
    setDownloading(true);
    const data = invoice.merchantInvoiceCountDetails.map((item, index) => ({
      "№": index + 1,
      "Байгууллагын нэр": item.description,
      "Өрхийн тоо": item.count,
      "Нэгж үнэ": item.rate,
      "Нийт дүн": item.total,
    }));

    data.push({
      "№": "",
      "Байгууллагын нэр": "Нийт",
      "Өрхийн тоо": totalCount,
      "Нэгж үнэ": "",
      "Нийт дүн": totalAmount,
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Нэхэмжлэл");

    XLSX.writeFile(workbook, `invoice_count_${invoiceId}.xlsx`);
    setDownloading(false);
  };

  return (
    <Modal
      open={open}
      onCancel={close}
      closeIcon={null}
      style={{ top: 20 }}
      footer={
        <Button
          className={`${bg_button} ${bg_shadow} text-white hover:bg-green-600`}
          icon={<DownloadOutlined />}
          type="primary"
          onClick={exportToExcel}
          disabled={loading}
        >
          {downloading ? <Spin /> : "EXCEL татах"}
        </Button>
      }
      width={600}
    >
      <Spin spinning={loading} className="custom-green-spin">
        <div ref={printRef} className="p-4 text-sm text-gray-800">
          <h2 className="text-lg font-bold mb-4 text-center">
            Нэхэмжлэлийн дэлгэрэнгүй мэдээлэл
          </h2>
          {invoice?.merchantInvoiceCountDetails?.length > 0 ? (
            <table className="w-full text-sm border border-gray-300">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="border px-3 py-2 text-left">#</th>
                  <th className="border px-3 py-2 text-left">
                    Байгууллагын нэр
                  </th>
                  <th className="border px-3 py-2 text-right">Өрхийн тоо</th>
                  <th className="border px-3 py-2 text-right">Нэгж үнэ</th>
                  <th className="border px-3 py-2 text-right">Нийт дүн</th>
                </tr>
              </thead>
              <tbody>
                {invoice.merchantInvoiceCountDetails.map((item, idx) => (
                  <tr key={item.id}>
                    <td className="border px-3 py-2">{idx + 1}</td>
                    <td className="border px-3 py-2">{item.description}</td>
                    <td className="border px-3 py-2 text-right">
                      {item.count.toLocaleString()}
                    </td>
                    <td className="border px-3 py-2 text-right">
                      {moneyFormat(item.rate)}
                    </td>
                    <td className="border px-3 py-2 text-right">
                      {moneyFormat(item.total)}
                    </td>
                  </tr>
                ))}
                <tr className="font-bold bg-gray-50">
                  <td className="border px-3 py-2 text-center" colSpan={2}>
                    Нийт
                  </td>
                  <td className="border px-3 py-2 text-right text-green-700">
                    {totalCount?.toLocaleString()}
                  </td>
                  <td />

                  <td className="border px-3 py-2 text-right text-green-700">
                    {moneyFormat(totalAmount)} ₮
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <p className="text-center text-gray-500">
              Харагдах задралын мэдээлэл алга байна.
            </p>
          )}
        </div>
      </Spin>
    </Modal>
  );
};

export default CountPreview;
